require("./theme.css");

import Vue from 'vue'
Vue.config.productionTip = false

import store from './store';
import router from './router';
import env from "@env";
import VueGtag from 'vue-gtag';
import VueLazyload from 'vue-lazyload'
import VueEasyLightbox from 'vue-easy-lightbox'

import App from './App.vue'

Vue.use(VueGtag, {config: {id: env.GOOGLE_ANALYTICS}}, router);

Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: 'https://cdn.oshi-challe.jp/images/tp.gif',
    loading: 'https://cdn.oshi-challe.jp/images/tp.gif',
    attempt: 1
});

new Vue({
    router: router,
    store: store,
    render: h => h(App)
}).$mount('#app')
